<template>
  <v-jumbotron>
    <v-container fill-height>
      <v-layout>
        <v-flex>
          <h3 class="display-3">Hoşgeldiniz</h3>
          <v-divider class="my-3"></v-divider>
          <h4 v-if="userRole !== 'AppliedMerchantUser'">
            Panel üzerinden yetkileriniz dahilinde aşağıdaki işlemleri
            yapabilirsiniz:
          </h4>
          <br />
          <div v-if="userRole !== 'AppliedMerchantUser'">
            <ul>
              <li
                v-for="(item, index) in homeTexts.filter(
                  (x) => x.roles.find((t) => t == userRole) != null,
                )"
                :key="index"
              >
                {{ item.text }}
              </li>
            </ul>
          </div>

          <div class="apply-container" v-if="userRole == 'AppliedMerchantUser'">
            <div>
              <img style="border-radius: 6px;" src="@/assets/apply-hero.png" />
            </div>
            <div>
              <p>
                Ön onay süreciniz başarıyla tamamlandı. Şimdi, ikinci adım
                olarak gerekli belgeleri sisteme yüklemeniz gerekmektedir.
                Lütfen belgelerinizi eksiksiz ve doğru bir şekilde yükleyerek
                süreci tamamlayınız. Herhangi bir sorunuz olursa, destek
                ekibimizle
                <a href="mailto:partners@frink.com.tr">partners@frink.com.tr</a>
                adresinden iletişime geçebilirsiniz.
              </p>
              <div class="d-flex justify-end">
                <v-btn color="#4F3CEF" @click='onClickApply'>
                  Başvuru
                </v-btn>
              </div>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-jumbotron>
</template>

<script>
export default {
  name: 'Home',
  data: () => ({
    homeTexts: [
      {
        text: 'Onboarding ekranları listeleme, ekleme ve düzenleme',
        roles: ['PanelUser'],
      },
      {
        text:
          'Panel ve Merchant App kullanıcıları listeleme, ekleme ve düzenleme',
        roles: ['PanelUser'],
      },
      {
        text: 'Mağaza listeleme, ekleme ve düzenleme',
        roles: ['PanelUser', 'PanelVenueUser'],
      },
      {
        text: 'Firma listeleme, ekleme ve düzenleme',
        roles: ['PanelUser'],
      },
      {
        text: 'Sipariş verme sürelerini listeleme, ekleme ve düzenleme',
        roles: ['PanelUser'],
      },
      {
        text: 'Satış ve mağaza satış raporlarını görüntüleme',
        roles: ['PanelUser', 'PanelVenueUser', 'PanelReportUser'],
      },
      {
        text: 'Satış ve mağaza satış raporları excel export',
        roles: ['PanelUser', 'PanelVenueUser', 'PanelReportUser'],
      },
      {
        text: 'Panel kullanıcıları listeleme',
        roles: ['PanelVenueUser'],
      },
      {
        text: 'Merchant App kullanıcıları listeleme, ekleme ve düzenleme',
        roles: ['PanelVenueUser'],
      },
      {
        text:
          'Başvurunuzun ön onayı kabul edildi. Başvuru Yönetimi menüsünden ilgili belgeleri yükleyiniz.',
        roles: ['AppliedMerchantUser'],
      },
    ],
    userRole: '',
  }),
  created() {
    let roles = JSON.parse(localStorage.getItem('userRoles'))
    this.userRole = roles[0]
  },
  methods: {
    onClickApply() {
      this.$router.push('/dashboard/apply/merchant')
    }
  }
}
</script>

<style>
.apply-container {
  display: flex;
  gap: 16px;
}
.apply-container p {
  text-align: justify;
}
.apply-container button {
  color: white !important;
  text-transform: capitalize;
}
@media only screen and (max-width: 768px) {
  .apply-container {
    flex-direction: column;
  }
}
</style>
